;(function () {
	const initProductAccordion = () => {
		const aboutToggleItems = $('.about__accordion-toggle')

		aboutToggleItems.each(function () {
			const currentToggle = $(this)
			const siblingToggles = currentToggle.siblings(
				'.about__accordion-description'
			)

			currentToggle.click(function () {
				if (!currentToggle.hasClass('active')) {
					aboutToggleItems.each(function () {
						const siblingToggle = $(this)
						siblingToggle.removeClass('active')
						siblingToggle
							.siblings('.about__accordion-description')
							.stop()
							.slideUp(300)
					})

					currentToggle.addClass('active')

					siblingToggles.stop().slideDown(300)
				} else {
					currentToggle.removeClass('active')
					siblingToggles.stop().slideUp(300)
				}
			})
		})
	}

	const initZoomImage = () => {
		const imagesWrapper = document.querySelector('.product-media-modal__content')
		if (!imagesWrapper) return

		const images = imagesWrapper.querySelectorAll('.js-image-zoom')

		images.forEach((img) => {
			let isZoomed = false
			let isDragging = false
			let translateX = 0, translateY = 0, lastTranslateX = 0, lastTranslateY = 0
			let startX, startY
			const SCALE = 2.5

			let naturalW = 0, naturalH = 0, containerW = 0, containerH = 0

			const captureLayout = () => {
				const parentRect = img.parentElement.getBoundingClientRect()
				containerW = parentRect.width
				containerH = parentRect.height
				const imgRect = img.getBoundingClientRect()
				naturalW = imgRect.width
				naturalH = imgRect.height
			}

			const clampTranslate = (tx, ty) => {
				const scaledW = naturalW * SCALE
				const scaledH = naturalH * SCALE
				const maxX = Math.max(0, (scaledW - containerW) / 2)
				const maxY = Math.max(0, (scaledH - containerH) / 2)
				return {
					x: Math.min(maxX, Math.max(-maxX, tx)),
					y: Math.min(maxY, Math.max(-maxY, ty)),
				}
			}

			const applyTransform = (tx, ty, scale, animate = false) => {
				img.style.transition = animate ? 'transform 0.2s ease' : 'none'
				img.style.transform = `translate(${tx}px, ${ty}px) scale(${scale})`
			}

			const reset = () => {
				translateX = 0
				translateY = 0
				lastTranslateX = 0
				lastTranslateY = 0
				isZoomed = false
				isDragging = false
				img.style.transition = 'none'
				img.style.transform = ''
				img.style.cursor = ''
				imagesWrapper.classList.remove('zoom')
				const popupSwiper = document.querySelector('.js-popup-slider')?.swiper
				if (popupSwiper) popupSwiper.allowTouchMove = true
			}

			const zoomIn = (clientX, clientY) => {
				captureLayout()
				const offsetX = clientX - (img.getBoundingClientRect().left + naturalW / 2)
				const offsetY = clientY - (img.getBoundingClientRect().top + naturalH / 2)
				const rawTx = -offsetX * (SCALE - 1)
				const rawTy = -offsetY * (SCALE - 1)
				const { x, y } = clampTranslate(rawTx, rawTy)
				translateX = x
				translateY = y
				lastTranslateX = x
				lastTranslateY = y
				applyTransform(x, y, SCALE, true)
				isZoomed = true
				imagesWrapper.classList.add('zoom')
				img.style.cursor = 'grab'
				const popupSwiper = document.querySelector('.js-popup-slider')?.swiper
				if (popupSwiper) popupSwiper.allowTouchMove = false
			}

			img.addEventListener('click', (e) => {
				if (isDragging) return
				if (!isZoomed) {
					zoomIn(e.clientX, e.clientY)
				} else {
					reset()
				}
			})

			img.addEventListener('mousedown', (e) => {
				if (!isZoomed) return
				isDragging = false
				startX = e.clientX - lastTranslateX
				startY = e.clientY - lastTranslateY
				img.style.cursor = 'grabbing'
				img.style.transition = 'none'

				const onMouseMove = (e) => {
					isDragging = true
					const rawTx = e.clientX - startX
					const rawTy = e.clientY - startY
					const { x, y } = clampTranslate(rawTx, rawTy)
					translateX = x
					translateY = y
					applyTransform(x, y, SCALE)
				}

				const onMouseUp = () => {
					lastTranslateX = translateX
					lastTranslateY = translateY
					img.style.cursor = 'grab'
					document.removeEventListener('mousemove', onMouseMove)
					document.removeEventListener('mouseup', onMouseUp)
					setTimeout(() => { isDragging = false }, 0)
				}

				document.addEventListener('mousemove', onMouseMove)
				document.addEventListener('mouseup', onMouseUp)
			})

			let lastTouchDist = null
			let touchStartX, touchStartY

			img.addEventListener('touchstart', (e) => {
				if (e.touches.length === 2) {
					lastTouchDist = Math.hypot(
						e.touches[0].clientX - e.touches[1].clientX,
						e.touches[0].clientY - e.touches[1].clientY
					)
				} else if (e.touches.length === 1 && isZoomed) {
					touchStartX = e.touches[0].clientX - lastTranslateX
					touchStartY = e.touches[0].clientY - lastTranslateY
				}
			}, { passive: true })

			img.addEventListener('touchmove', (e) => {
				if (e.touches.length === 2) {
					e.preventDefault()
					const dist = Math.hypot(
						e.touches[0].clientX - e.touches[1].clientX,
						e.touches[0].clientY - e.touches[1].clientY
					)
					if (lastTouchDist && dist > lastTouchDist * 1.1) {
						const midX = (e.touches[0].clientX + e.touches[1].clientX) / 2
						const midY = (e.touches[0].clientY + e.touches[1].clientY) / 2
						zoomIn(midX, midY)
					} else if (lastTouchDist && dist < lastTouchDist * 0.9) {
						reset()
					}
					lastTouchDist = dist
				} else if (e.touches.length === 1 && isZoomed) {
					e.preventDefault()
					const rawTx = e.touches[0].clientX - touchStartX
					const rawTy = e.touches[0].clientY - touchStartY
					const { x, y } = clampTranslate(rawTx, rawTy)
					translateX = x
					translateY = y
					applyTransform(x, y, SCALE)
				}
			}, { passive: false })

			img.addEventListener('touchend', () => {
				lastTouchDist = null
				lastTranslateX = translateX
				lastTranslateY = translateY
			})

			img._zoomReset = reset
		})

		const modalCloseBtn = document.querySelector('#ModalClose-' +
			imagesWrapper.closest('product-modal')?.id?.replace('ProductModal-', ''))
		if (modalCloseBtn) {
			modalCloseBtn.addEventListener('click', () => {
				imagesWrapper.querySelectorAll('.js-image-zoom').forEach(img => {
					if (img._zoomReset) img._zoomReset()
				})
			})
		}
	}

	const formatFreeShippingAmount = (value) => {
		const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/
		const formatString = theme.moneyFormat

		return formatString.replace(placeholderRegex, value)
	}

	const setTotalFreeShipping = () => {
		if (document.querySelector('.js-free-shipping')) {
			const freeShippingTotal = document.querySelector('.free-shipping-total')
			if (freeShippingTotal) {
				const minSpend = Number(freeShippingTotal.dataset.minSpend)
				if (minSpend && minSpend > 0) {
					freeShippingTotal.innerText = `${formatFreeShippingAmount(
						Math.round(minSpend * (Shopify.currency.rate || 1))
					)}`
				}
			}
		}
	}
	function changeIconsViewBox() {
		const textWithIcon = document.querySelectorAll('.text_with_icon')
		textWithIcon.forEach((item) => {
			const icons = item.querySelectorAll('.icon-pack')
			icons.forEach((icon) => {
				icon.setAttribute('viewBox', '0 0 20 20')
			})
		})
	}

	//document.addEventListener('scroll', () => {
	//	const navigation = document.querySelector('.product__media_navigation')
	//	if (navigation) {
	//		const footer = document.querySelector('.footer')
	//		const navigationHeight = navigation.offsetHeight
	//		const screen = window.scrollY
	//		const overview = document.querySelector('#overview').scrollTop
	//		const overviewBottom =
	//			document.querySelector('#overview').clientHeight + overview
	//		if (screen >= overview && screen <= overviewBottom) {
	//			document.querySelector('#overview-link').classList.add('active')
	//		} else {
	//			document.querySelector('#overview-link').classList.remove('active')
	//		}
	//		if (window.innerHeight + screen - navigationHeight > footer.offsetTop) {
	//			navigation.style.opacity = '0'
	//			navigation.style.visibility = 'hidden'
	//		} else {
	//			navigation.style.opacity = '1'
	//			navigation.style.visibility = 'visible'
	//		}
	//	}
	//})

	const navigationSections = [
		{
			sectionSelector: '#overview',
			linkSelector: '#overview-link',
		},
		{
			sectionSelector: '#product-specifications',
			linkSelector: '#specifications-link',
		},
	]

	function navigationInit(sections) {
		const navigation = document.querySelector('.product__media_navigation')
		if (navigation) {
			navigation.style.transform = 'translateX(-50%) translateY(calc(100% + 16px))'
		}
		document.addEventListener('scroll', () => {
			if (navigation) {
				navigation.classList.add('show-navigation')
			}
			if (navigation) {
				const footer = document.querySelector('.footer')
				const navigationHeight = navigation.offsetHeight
				const secondSection = document.querySelectorAll('#MainContent .shopify-section')[1]
				const screen = window.scrollY
				sections.forEach((section, i) => {
					if (section) {
						const em = document.querySelector(`${section.sectionSelector}`)
						if (em) {
							const rect = em.getBoundingClientRect()	
							if (rect.top <= 1 && rect.top > rect.height * -1) {
								document
									.querySelector(`${section.linkSelector}`)
									.classList.add('active')
							} else {
								document
									.querySelector(`${section.linkSelector}`)
									.classList.remove('active')
							}
							document.querySelector(`${section.linkSelector}`).addEventListener('click', () => {
								em.scrollIntoView({ behavior: 'smooth' });
							})
						} else {
							document.querySelector(`${section.linkSelector}`).style.display = 'none';
						}
					}
				})
				
				const rect = secondSection.getBoundingClientRect();
				const isSecondSectionScrolled = rect.top < 0;
				const isNearFooter = window.innerHeight + screen - navigationHeight > footer.offsetTop;

				navigation.style.transform = isSecondSectionScrolled && !isNearFooter
				? 'translateX(-50%) translateY(0)'
				: 'translateX(-50%) translateY(calc(100% + 16px))';
			}
		})
	}

	document.addEventListener('shopify:section:load', function () {
		initProductAccordion()
		initZoomImage()
		setTotalFreeShipping()
		changeIconsViewBox()
		navigationInit(navigationSections)
	})

	navigationInit(navigationSections)
	initProductAccordion()
	initZoomImage()
	setTotalFreeShipping()
	changeIconsViewBox()
})()
